import * as THREE from 'three'

class IntersectableObject extends THREE.Object3D{

    constructor(){
        super()
    }

    checkForIntersects(evt) {
        if (evt && evt.intersect && evt.intersect.object && evt.intersect.object.uuid) {
            let intersecting = false
            if (evt.intersect.object.uuid === this.uuid) intersecting = evt.intersect
            if (this.children && !intersecting) intersecting = checkChildren(this.children, evt.intersect)
            return intersecting
        }
        else return false
    }


}

function checkChildren(children, intersect){
    let intersecting = false
    for (const child of children) {
        if (intersect.object.uuid === child.uuid) intersecting = intersect
        if (!intersecting && child.children) intersecting = checkChildren(child.children, intersect)
    }
    return intersecting
}
export default IntersectableObject